import { US_CONFIG } from './usAddressConfig'
import { CA_CONFIG } from './caAddressConfig'
import { GB_CONFIG } from './gbAddressConfig'
import { IE_CONFIG } from './ieAddressConfig'
import { AU_CONFIG } from './auAddressConfig'
import { NZ_CONFIG } from './nzAddressConfig'
import { DeliveryInfo, DeliveryInfoInput } from 'src/apollo/onlineOrdering'

import { CountryAddressConfig } from './types'
import {
  formatDeliveryAddressUtil,
  getMissingRequiredFieldErrorsUtil,
  normalizeGoogleAddressUtil
} from './utils'

import { formatDeliveryAddress as formatDeliveryAddressWithoutConfigs } from 'src/public/components/online_ordering/addressUtils'

export type { CountryAddressConfig, AddressFieldConfig } from './types'
export { createDefaultFormatters, createStandardConfig } from './utils'

export const COUNTRY_ADDRESS_CONFIGS: Record<string, CountryAddressConfig> = {
  US: US_CONFIG,
  CA: CA_CONFIG,
  GB: GB_CONFIG,
  IE: IE_CONFIG,
  AU: AU_CONFIG,
  NZ: NZ_CONFIG
}

/**
 * Get the address configuration for a given country code
 * Defaults to US if country code is not provided or not found
 */
export const getCountryAddressConfig = (
  countryCode?: string | null
): CountryAddressConfig => {
  if (!countryCode) {
    return US_CONFIG
  }

  return COUNTRY_ADDRESS_CONFIGS[countryCode] ?? US_CONFIG
}

/**
 * Validate address and return array of error translation keys for missing required fields
 */
export const getMissingRequiredFieldErrors = (
  address: DeliveryInfoInput | null,
  countryCode?: string | null
): string[] => {
  return getMissingRequiredFieldErrorsUtil(
    address,
    getCountryAddressConfig,
    countryCode
  )
}

/**
 * Normalize a Google Places result into DeliveryInfoInput format
 */
export const normalizeGoogleAddress = (
  addressFromGoogle: google.maps.places.PlaceResult,
  rxCountry?: string | null
) => {
  return normalizeGoogleAddressUtil(
    addressFromGoogle,
    getCountryAddressConfig,
    rxCountry
  )
}

export const formatDeliveryAddress = (
  address: DeliveryInfo | null,
  options: {
    full?: boolean
    includeAddress2?: boolean
    includeZip?: boolean
    country?: string | null
  } = {},
  shouldUseIntlConfigs: boolean
) => {
  // use original formatting function from addressUtils if FF is off
  return shouldUseIntlConfigs
    ? formatDeliveryAddressUtil(address, options, getCountryAddressConfig)
    : formatDeliveryAddressWithoutConfigs(address, options)
}
